// extracted by mini-css-extract-plugin
export default {"loading-dialog":"loading-dialog_loading-dialog__ySGlZ","show":"loading-dialog_show__8ot7x"};